import { Divider, styled } from "@mui/material";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";

const HeaderText = styled("p")({
  fontSize: "16px",
  fontWeight: 700,
  lineHeight: "24px",
});

const CustomDivider = styled(Divider)(({ theme }) => ({
  marginTop: "16px",
  borderColor: "#cccccc",
}));

const DeliveryService = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <HeaderText>{t("deliveryServiceHeader")}</HeaderText>
      <CustomDivider />
      <div
        style={{
          marginTop: "16px",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          fontWeight: 700,
        }}
      >
        <span>{t("deliveryServiceHeaderDescription1")}</span>
        <span>{t("deliveryServiceHeaderDescription2")}</span>
        <span>{t("deliveryServiceHeaderDescription3")}</span>
        <span>{t("deliveryServiceHeaderDescription4")}</span>
        <span>{t("deliveryServiceHeaderDescription5")}</span>
        <span>{t("deliveryServiceHeaderDescription6")}</span>
      </div>
    </Box>
  );
};

export default DeliveryService;
